import { render, staticRenderFns } from "./ModalHOC.vue?vue&type=template&id=2ae77fe4&scoped=true&"
import script from "./ModalHOC.vue?vue&type=script&lang=js&"
export * from "./ModalHOC.vue?vue&type=script&lang=js&"
import style0 from "./ModalHOC.vue?vue&type=style&index=0&id=2ae77fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae77fe4",
  null
  
)

export default component.exports